import { AppConfig } from './types';

/**
 * Default configuration that applies to all environments and will load as local
 */
export const localConfig: AppConfig = {
    proctoring: {
      api: {
        baseUrl: 'http://localhost:8011',
        timeout: 30000,
        retry: true,
        retryAttempts: 3
      },
      ui : {
        baseUrl: 'http://localhost:4000',
        secondCamera: {
          deviceBaseUrl: 'https://jasonfill.ngrok.io',
        }
      }
    },
    assessment: {
      api: {
        baseUrl: 'http://localhost:8010',
        timeout: 30000,
        retry: true,
        retryAttempts: 3
      }
    },
    core : {
      api: {
        baseUrl: 'http://localhost:8013',
        timeout: 30000,
        retry: true,
        retryAttempts: 3
      }
    },
    media : {
      api: {
        baseUrl: 'http://localhost:8012',
        timeout: 30000,
        retry: true,
        retryAttempts: 3
      },
      playback: {
        baseUrl: 'http://localhost:8012',
      },
      livekit: {
        websocketUrl: 'wss://media-dev-nyc1.proctoring.media',
      }
    },
  elements: {
    ui : {
      baseUrl: 'http://localhost:4000',
    }
  }
};
